<template>
	<div class="row">
		<div class="col-sm-6 col-lg-4 col-xl-3 card-container" v-for="(item, index) in visibleItems">
			<erco-object-card
				:title="item.S_de_Objekt"
				:type="item.S_Zusatz"
				:imageSrc="item.S_Stellvertreterbild"
				:date="item.TS_Aenderungsdatum"
				:publishdate="item.TS_online_Liveserver"
				:offlinedate="item.TS_offline_Liveserver"
				:objectId="item.PKM_Objekt"
				:status="item.S_Status"
				:onlineUrl="item.onlineUrl"
				:previewUrl="item.previewUrl"
				:isProductive="item.isProductive"
				:checked="belongsToSelection(item.PKM_Objekt)"
				:category="item.S_Bereich"
				:specification="item.S_Spezifikation"
				:genus="item.S_Gattung"
				></erco-object-card>
		</div>
	</div>
</template>
<script>
	import ErcoObjectCard from '@/components/molecules/ErcoObjectCard';

	export default {
		name: 'ErcoObjectCardOverviewOrganism',
		data() {
			return {
				currentContentIndex: 0,
				innerVisibleItemsNum: 0,
			};
		},
		props: {
			items: {
				type: Array,
				required: true,
				default() {
					return [
					];
				},
			},
			headline: {
				type: String,
				required: false,
				default: 'headline',
			},
			ismultiline: {
				type: Boolean,
				default: false,
			},
			visibleItemsNum: {
				type: Number,
				default: 12,
			},
			disabledItemRestriction: {
				type: Boolean,
				default: false,
			},
		},
		computed: {
			visibleItems() {
				if (this.disabledItemRestriction) {
					return this.items;
				}

				return this.items.slice(0, this.innerVisibleItemsNum || this.visibleItemsNum);
			},
			selectedObjectIds() {
				return this.$store.state.dashboard.selectedObjectIds;
			},
		},
		methods: {
			belongsToSelection(objID) {
				const parsedObjID = parseInt(objID, 10);
				return this.selectedObjectIds.includes(parsedObjID);
			},
		},
		watch: {
			visibleItemsNum(newVisibleItemsNum) {
				this.$set(this, 'innerVisibleItemsNum', newVisibleItemsNum);
			},
		},
		components: {
			ErcoObjectCard,
		},
	};
</script>

<style lang="scss">

	.card-container {
		display: flex;
	}

</style>



// WEBPACK FOOTER //
// ErcoObjectCardOverview.vue?e9c8057c